var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"mb-3":""}},[_c('h2',{staticClass:"headline"},[_vm._v("Here you may create additional field")])]),_vm._v(" "),(_vm.isWriteAvailable)?_c('FormConstructor'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d7e2e7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Registration/Settings/FormConstuctorRegistrationAttendee.vue
// module id = null
// module chunks = 